import {
  AccessTokenResponse,
  AccessTokenRequest,
  AuthRoutes,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterCode,
  RegisterCodeListResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest
} from '@foxbun/lib-goferal-types';
import { AbstractClient } from '@foxbun/lib-sdk';

export class GoFeralAuthClient extends AbstractClient {
  login(params: LoginRequest) {
    return this.post({
      path: AuthRoutes.LOGIN,
      req: LoginRequest,
      res: LoginResponse,
      params: params
    });
  }

  forgotPassword(params: ForgotPasswordRequest) {
    return this.post({
      path: AuthRoutes.FORGOT_PASSWORD,
      req: ForgotPasswordRequest,
      params: params
    });
  }

  resetPassword(params: ResetPasswordRequest) {
    return this.post({
      path: AuthRoutes.RESET_PASSWORD,
      req: ResetPasswordRequest,
      params: params
    });
  }

  register(params: RegisterRequest) {
    return this.post({
      path: AuthRoutes.REGISTER,
      req: RegisterRequest,
      params: params
    });
  }

  accessToken(token: string, req: AccessTokenRequest) {
    return this.post({
      path: AuthRoutes.TOKEN,
      req: AccessTokenRequest,
      res: AccessTokenResponse,
      params: req,
      token: token
    });
  }

  generateRegistrationCode(token: string) {
    return this.post({
      path: AuthRoutes.REGISTER_CODE_GENERATE,
      res: RegisterCode,
      token: token
    });
  }

  listRegistrationCode(token: string) {
    return this.post({
      path: AuthRoutes.REGISTER_CODE_LIST,
      res: RegisterCodeListResponse,
      token: token
    });
  }
}
